define('shared/util/validate/validators/creditCard',['shared/lib/validate', 'shared/lib/RSVP'], function  (validate, RSVP) {
    'use strict';

    var KEY = 'creditCard';
    var REASON = 'Credit card format is not correct';

    function validator(value, options, key, attributes){
        return new RSVP.Promise(function( resolve, reject ){
            if ( validator.debug === true ) {
                resolve();
                return;
            }

            if(!value){
                reject('Empty credit card');
                return;
            }

            value = value.replace(/[\-\{\}\(\)\ ]/g, '');
            
            // Apply the Luhn algorithm
            var sum = 0;
            var alt = false;
            var num = 0;
            var cur = value.charAt(i);

            // Walk backwards through the number string
            for (var i = value.length - 1; i >= 0; i--) {

                // Get the numeric value for the current index
                cur = value.charAt(i);
                num = cur >> 0;

                if ( num != cur ) {
                    reject( options.message || REASON );
                    return;
                }

                if (alt) {
                    num *= 2;
                    if (num > 9) {
                        num -= 9;
                    }
                }

                sum += num;
                alt = !alt;
            }

            // Mod 10
            if (sum % 10 === 0 && sum > 0) {
                resolve();
            }
            else {
                reject( options.message || REASON );
            }
        });
    }

    // register to validate js
    validate.validators[KEY] = validator;
    validator.KEY = KEY;

    return validator;

});
